import React, { FC, memo, useId } from "react"
import { InfoStyled, InputStyled, LabelStyled, RootStyled } from "./styles"

interface IProps {
  label: string
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  info?: string
}

export const Input: FC<IProps> = memo(({ label, inputProps, info }) => {
  const generatedId = useId()
  const id = inputProps?.id ?? generatedId

  return (
    <RootStyled>
      <LabelStyled htmlFor={id}>{label}</LabelStyled>
      <InputStyled {...inputProps} id={id} />
      <InfoStyled>{info}</InfoStyled>
    </RootStyled>
  )
})
